module.exports = (__webpack_require__(21))(180);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/core-js/library/modules/_ctx.js from dll-reference vendorLibrary
// module id = 704
// module chunks = 0